import { render, staticRenderFns } from "./CampaignMessageTemplate.html?vue&type=template&id=0158d230&scoped=true&external"
import script from "./CampaignMessageTemplate.js?vue&type=script&lang=js&external"
export * from "./CampaignMessageTemplate.js?vue&type=script&lang=js&external"
import style0 from "./CampaignMessageTemplate.scss?vue&type=style&index=0&id=0158d230&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0158d230",
  null
  
)

export default component.exports